import type { ComponentChildren, FunctionComponent } from "preact";
import { useMergedClassName } from "../utils.ts";

type PageHeaderProps = {
    title: string;
    subtitle?: string;
    actions?: ComponentChildren;
    class?: string;
};

export const PageHeader: FunctionComponent<PageHeaderProps> = (props: PageHeaderProps) => {
    const className = useMergedClassName("farpov_page_header", props.class);
    
    return (
        <div class={className}>
            <div class="farpov_page_header_content">
                <h2 class="farpov_page_title">{props.title}</h2>
                {props.subtitle && <p class="farpov_page_subtitle">{props.subtitle}</p>}
            </div>
            {props.actions && (
                <div class="farpov_page_actions">
                    {props.actions}
                </div>
            )}
        </div>
    );
};
